import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { Page, PageHeader, PageInner, PageSection } from "@app/shared";
import { preventDefaultMouseEvent } from "@app/shared/utility";
import { UserInfo } from "@app/user";
import { Profile } from "@app/user/account/manage";
import { JSX } from "react";

type ManageAccountTabType = "profile";

interface ManageAccountProps extends RouteComponentProps<unknown> {
  user: UserInfo;
}

interface ManageAccountState {
  activeTabType: ManageAccountTabType;
}

class ManageAccount extends React.Component<ManageAccountProps, ManageAccountState> {
  constructor(props: ManageAccountProps) {
    super(props);

    let activeTabType: ManageAccountTabType = "profile";
    const urlParts = this.props.location.pathname.split("/");

    if (urlParts.length === 4) {
      const urlActiveTabType = urlParts[3].toLowerCase() as ManageAccountTabType;
      if (urlActiveTabType !== undefined) {
        activeTabType = urlActiveTabType;
      }
    }

    this.state = {
      activeTabType,
    };
  }

  public render(): JSX.Element {
    return (
      <Page documentTitle="Update Account Information">
        <PageInner>

          <PageHeader title="Update Account Information" />

          <PageSection>
            <div className="row">
              <div className="col-12">

                <div className="tabs-style-2">
                  <ul className="nav nav-tabs">
                    {this.navItemFor("profile")}
                  </ul>
                </div>

                <div className="container-fluid px-0">
                  <div className="row">
                    <div className="col-12">
                      <div className="tabs-style-2">
                        <div className="tab-content">
                          <Switch>
                            <Route
                              path={`${this.props.match.path}/profile`}
                              render={() => <Profile {...this.props} />}
                            />
                          </Switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </PageSection>

        </PageInner>
      </Page>
    );
  }

  private isActiveTab = (tabType: ManageAccountTabType): boolean => {
    return this.state.activeTabType === (tabType);
  }

  private handleTabClick = (tabType: ManageAccountTabType) => {
    this.props.history.push(`${this.props.match.path}/${tabType}`);
    this.setState((prevState) => ({
      ...prevState,
      activeTabType: tabType,
    }));
  }

  private navItemFor(tabType: ManageAccountTabType): JSX.Element {
    const text = `${tabType.charAt(0).toUpperCase()}${tabType.slice(1)}`;
    return (
      <li className="nav-item">
        <a href="#" className={`nav-link${this.isActiveTab(tabType) ? " active" : ""}`} onClick={(e: React.MouseEvent) => preventDefaultMouseEvent(e, () => this.handleTabClick(tabType))}>{text}</a>
      </li>
    );
  }
}

export {
  ManageAccount,
};
